<template>
  <ReportBaseSelectFilter
    class="client-filter"
    label="Clients"
    placeholder="All clients"
    :options="options"
    query-property="clients"
  />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ReportClientFilter',
  computed: {
    ...mapGetters(['allClients']),
    options() {
      const result = [];
      const archivedClients = [];

      if (this.allClients?.length) {
        this.allClients.forEach((client) => {
          (client.archived ? archivedClients : result).push({
            id: client.id,
            text: client.name,
            archived: client.archived,
          });
        });

        if (archivedClients.length > 0) {
          result.push({
            text: 'Archived',
            children: archivedClients,
          });
        }
      }

      return result;
    },
  },
};
</script>
